import successImage from "../Assets/success-image.png";
import { Link } from "react-router-dom";
import "./show-success.css";

const ShowSuccess = ({ message, thanksyouMessage }) => {
    const thankyou = thanksyouMessage ? thanksyouMessage : "Thank you for submitting the reservation details. Our partner has shared an automated response for you."
    return (
        <div className="success-modal-container" style={{ position: "relative" }}>
            <div className="success-modal-content">
                <div className="success-card">
                    <div className="success-message">
                        <p>{message}</p>
                    </div>
                    <div className="success-image">
                        <img src={successImage} alt="" />
                    </div>
                    <div className="success-description">
                        <p>{thankyou}</p>
                    </div>
                    <div className="success-page-button">
                        <Link to="/">
                            <button>View Response</button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ShowSuccess;